<template>
  <div class="row">
    <div v-for="stat in statsData" :key="stat.label" class="col-sm-4 mb-1">
      <div class="card">
        <div class="card-body p-2">
          <p class="h6 text-muted" style="margin-bottom: 4px">
            {{ stat.label }}
          </p>
          <p class="h3" style="margin-bottom: 8px">{{ stat.value }}</p>
          <div class="progress" style="margin-bottom: 4px">
            <div
              :class="`progress-bar bg-${stat.color}`"
              role="progressbar"
              :style="{ width: stat.percentage + '%' }"
            ></div>
          </div>
          <small :class="`text-${stat.color}`"
            >{{ stat.percentage }}% du total ({{ workplaces.length }})</small
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    workplaces: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    statsData() {
      if (!this.workplaces) {
        return [];
      }

      const total = this.workplaces.length;

      return [
        {
          label: "Fiches remplies",
          value: this.workplaces.filter((w) => w.isProperlyFilled).length,
        },
        {
          label: "Emails Linkedin envoyés",
          value: this.workplaces.filter((w) => w.linkedinEmailSentAt).length,
        },
        {
          label: "Leads B2B envoyés",
          value: this.workplaces.filter((w) => w.leadSentToB2bCommercialAt)
            .length,
        },
        {
          label: "Prises de contact lead B2B",
          value: this.workplaces.filter((w) => w.contactedAt).length,
        },
        {
          label: "Audits",
          value: this.workplaces.filter((w) => w.auditAt).length,
        },
        {
          label: "Ventes",
          value: this.workplaces.filter((w) => w.saleAt).length,
        },
      ]
        .map((s) => ({
          ...s,
          percentage: total > 0 ? Math.round((s.value / total) * 100) : 0,
        }))
        .map((s) => ({
          ...s,
          color:
            s.percentage === 0
              ? "muted"
              : s.percentage < 33
              ? "danger"
              : s.percentage < 66
              ? "warning"
              : "success",
        }));
    },
  },
};
</script>
